<template lang="pug">
  .eventActivity(v-if="eventActivity")
    .banner(v-if="eventActivity.file")
      img(:src="eventActivity.file.url" style="width: 100%;height: auto;")
    .container
      .d-flex.align-items-center.justify-content-center(style="flex-direction: column;")
        .mb-2(style="font-weight: bold; font-size: 1.2rem;") {{ eventActivity.name }}
        div {{ eventActivity.desc }}
    .line
    .container
      .d-flex.align-items-center.justify-content-center
        div(style="letter-spacing: 5px; font-weight: bold; font-size: 1.2rem; margin-bottom: 5px;") 我要預約
      .d-flex.align-items-center.justify-content-center(style="flex-direction: column;")
        input.inputStyle(
        type='text', placeholder="請輸入姓名" v-model='userInfo.name')
        input.inputStyle(
        type='text', placeholder="請輸入行動電話" v-model='userInfo.mobile')
      .multiselect_custom_homePage
        multiselect(
          track-by="pivot.id",
          label="title",
          placeholder="請選擇櫃點",
          :options="eventActivity.open_stores",
          :searchable="false",
          :allow-empty="false",
          v-model="userInfo.selectedStore",
          selectLabel='',
          deselect-label='',
          @input='getStoreActivityTimeList'
          noOptions="無可選擇櫃點"
        )
          template(slot="noOptions")
            strong 無可選擇櫃點
      .multiselect_custom_homePage
        multiselect(
          track-by="activity_start_at",
          label="activity_start_at",
          placeholder="請選擇活動日期",
          :options="storeTimeListFilter",
          :searchable="false",
          :allow-empty="false",
          v-model="userInfo.selectedDate",
          selectLabel='',
          deselect-label='',
          @input='getStoreActivitySession'
          noOptions="無可選擇日期"
        )
          template(slot="noOptions")
            strong 無可選擇日期
      .multiselect_custom_homePage
        multiselect(
          track-by="id",
          label="period_limit",
          placeholder="請選擇活動時段",
          :options="activitySessionList",
          :searchable="false",
          :allow-empty="false",
          v-model="userInfo.selectedTime",
          selectLabel='',
          deselect-label='',
          noOptions="無可選擇時段"
        )
          template(slot="noOptions")
            strong 無可選擇時段
      textarea.inputStyle.textareaStyle.d-flex.align-items-center.justify-content-center(
      type='text', placeholder="請輸入備註" v-model='userInfo.remark', style="margin: 5px 0;")
    .line
    .container
      .mb-3(style="font-weight: bold; text-align: center; font-size: 1.2rem;") 活動聲明
      b-form-checkbox(
          id="stmt_first"
          v-model='userInfo.stmt_first'
          name='agreeUseRule'
          ) 我同意
        .mb-2(style="white-space: pre-wrap;") {{ eventActivity.stmt_first }}
      b-form-checkbox(
          v-if="needCheckStmtLast"
          id="stmt_last"
          v-model='userInfo.stmt_last'
          name='agreeUseRule'
          ) 我同意
        .mb-2(style="white-space: pre-wrap;") {{ eventActivity.stmt_last }}
      button.btn.btn-primary.mt-4.mb-3(type="button", @click="goItemList()", style="width: 100%;")
        span(style="margin-right: 10px;") 送出
  div.text-center(v-else-if='not_member')
  div.text-center(v-else)
    h4.mt-3 目前無活動
    .position-absolute(style="bottom: 0; left: 50%; transform: translate(-50%, -50%);")
      button.btn.px-3.btn-primary(
        type="button",
        @click="backToLINEHandler()"
      ) 返回官方帳號

</template>

<script>
import { mapState } from 'vuex';
import { M_EVENT_ACTIVITY_SUCCESS } from '@/router/member/event-activity';
import { M_EVENT_ACTIVITY_PAYMENT } from '@/router/member/event-activity';

const _ = require('lodash');
const moment = require('moment');

  export default {

// 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'event-activity-member-create',
  props: {
    id: [String, Number]
  },
  data() {
    return {
      couponList: [],
      testStoreOptions: [{ id: 1, store: '台北101店' }, { id: 2, store: '台中遠百店' }],
      actInfo: {
        title: '活動主題活動主題',
        content: '活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明',
        actImg: 'https://images.chinatimes.com/newsphoto/2017-03-17/1024/20170317005512.jpg',
        hint: ['1. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。', '2. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。', '3. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。'],
        actDateList: ['2021/12/01', '2021/12/02', '2021/12/03'],
        actDateTimeList: ['11:00', '14:00', '17:00']
      },
      userInfo: {
        remark: ''
      },
      agreeUseRule: [],
      activitySessionList: [],
      isSend: false,
      not_member: false,
      needCheckStmtLast: false
    };
  },
  methods: {
    moment(val) {
      return moment(val);
    },
    goItemList() {
      const vm = this;
      const MobileReg = /^(09)[0-9]{8}$/;
      if (!vm.userInfo.name) {
        vm.$swal.fire({
          title: '請輸入姓名',
          icon: 'info'
        });
      } else if (!vm.userInfo.mobile) {
        vm.$swal.fire({
          title: '請輸入行動電話',
          icon: 'info'
        });
      } else if (!MobileReg.test(vm.userInfo.mobile)) {
        vm.$swal.fire({
          title: '行動電話格式錯誤',
          icon: 'info'
        });
      } else if (!vm.userInfo.selectedStore) {
        vm.$swal.fire({
          title: '請選擇專門店',
          icon: 'info'
        });
      } else if (!vm.userInfo.selectedDate) {
        vm.$swal.fire({
          title: '請選擇活動日期',
          icon: 'info'
        });
      } else if (!vm.userInfo.selectedTime) {
        vm.$swal.fire({
          title: '請選擇活動時段',
          icon: 'info'
        });
      } else if (!vm.userInfo.stmt_first || (!vm.userInfo.stmt_last && vm.needCheckStmtLast)) {
        vm.$swal.fire({
          title: '請同意所有活動聲明',
          icon: 'info'
        });
      } else {
        if (vm.isSend) return;
        vm.isSend = true;

        vm.$swal.fire({
          title: '資料送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        const data = {
          activity_reserve_detail_id: vm.userInfo.selectedTime.id,
          meta: {
            name: vm.userInfo.name,
            mobile: vm.userInfo.mobile
          },
          user_note: vm.userInfo.remark
        };

        vm.$store.dispatch('member_event_activity/sendEventActivityHandler', data).then((res) => {
          vm.$store.commit('member_event_activity/setUserInfo', vm.userInfo);
          vm.$swal.close();

          vm.isSend = false;
          vm.$swal.fire({
            icon: 'success',
            html: '預約已建立',
            confirmButtonText: '前往付款',
            showCancelButton: true,
            cancelButtonText: '稍後付款',
            reverseButtons: true,
          }).then((result) => {
            if (result.value) {
              vm.$router.push({ name: M_EVENT_ACTIVITY_PAYMENT, params: { paymentInfo: res.data } });
            } else {
              vm.backToLINEHandler();
            }
          });
          // 改為串接金流
          // vm.$router.push({ name: M_EVENT_ACTIVITY_SUCCESS });
        }).catch(() => {
          vm.isSend = false;
        });
      }
    },
    getStoreActivityTimeList(val) {
      const vm = this;
      vm.$set(vm.userInfo, 'selectedDate', null);
      vm.$set(vm.userInfo, 'selectedTime', null);
      vm.$set(vm, 'activitySessionList', []);
      this.$nextTick(() => {
        vm.$swal.fire({
          title: '取得日期時段中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });
        vm.$store.dispatch('member_event_activity/getStoreTimeListHandler', val.pivot.id).then(() => {
          vm.$swal.close();
        });
      });
    },
    getStoreActivitySession(val) {
      const vm = this;
      vm.$set(vm.userInfo, 'selectedTime', null);
      vm.$set(vm, 'activitySessionList', []);
      vm.activitySessionList = val.activity_detail;
    },
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  },
  watch: {
    'userInfo.mobile': function (val) {
      this.userInfo.mobile = String(val).replace(/[^0-9]+$/, '');
    }
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', true);
    // 清除活動日期
    vm.$store.commit('member_event_activity/setStoreTimeList', []);
    vm.$store.dispatch('member_event_activity/checkBindingHandler').then((res) => {
      if (res.type === 'personnel') {
        vm.not_member = true;
        vm.$store.commit('toggleLoading', false);
        vm.$swal.fire({
          title: '您非符合報名身份',
          confirmButtonText: '關閉'
        }).then(() => {
          vm.backToLINEHandler();
        });
        return;
      }
      vm.$store.dispatch('member_event_activity/getEventActivityHandler', vm.id).then((res) => {
        vm.$store.commit('toggleLoading', false);
        if (vm.eventActivity.is_enabled === 0) {
          vm.$swal.fire({
            title: '活動已結束',
            confirmButtonText: '關閉'
          }).then(() => {
            vm.backToLINEHandler();
          });
        }
        if (vm.eventActivity) {
          vm.userInfo.eventActivity = vm.eventActivity;
          vm.needCheckStmtLast = vm.eventActivity.stmt_last !== '' && vm.eventActivity.stmt_last !== null;
        } else {
          vm.$swal.fire({
            title: '目前無活動',
            confirmButtonText: '關閉'
          }).then(() => {
            vm.backToLINEHandler();
          });
        }
      });
    });
    // 正式串接時這個這個要放到取得 actInfo 之後的 .then
    for (let i = 0; i < this.actInfo.hint.length; i++) {
      this.agreeUseRule.push(false);
    }
  },
  computed: {
    ...mapState({
      eventActivity: (state) => state.member_event_activity.eventActivity,
      storeTimeList: (state) => state.member_event_activity.storeTimeList
    }),
    storeTimeListFilter() {
      const vm = this;
      // 如果今日的時候都過期就移除今日的選項
      if (vm.storeTimeList && vm.storeTimeList.length > 0 && vm.storeTimeList[0].activity_start_at === moment().format('YYYY-MM-DD')) {
        if (_.filter(vm.storeTimeList[0].activity_detail, (val) => moment(val.activity_start_at).isBefore(moment()))) {
          // return _.clone(vm.storeTimeList);
          const newArr = _.clone(vm.storeTimeList);
          newArr.splice(0, 1);
          return newArr;
        }
      }
      return vm.storeTimeList;
    }
  }
};
</script>
<style lang="scss" scoped>
.line {
  border-top: solid 1px #aaa;
  width: 100%;
  height: 1px;
}

.container {
  padding: 35px 20px;
  text-align: left;
}

.inputStyle {
  width: 100%;
  padding: 15px;
  text-align: center;
  margin: 5px;
  border: none;
  background: #eee;
}
.footer {
  border-top: solid #aaa 1px;
  padding: 20px;
}
.multiselect_custom_homePage {
  padding: 5px 0;
  & .multiselect__placeholder {
    color: #828282;
    margin-left: 20px;
    font-size: 1rem;
  }
  & .multiselect__tags {
    border: solid #888 1px;
    border-radius: 3px;
    min-height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & .multiselect__input, .multiselect__single {
    text-align: center;
  }
  & .multiselect__select {
    top: 9px;
  }
  & .multiselect__content-wrapper {
    text-align: center;
  }
}
textarea:hover, input:hover, textarea:active, input:active, textarea:focus, input:focus, button:focus, button:active, button:hover, label:focus, .btn:active, .btn.active {
  outline: 0px !important;
  -webkit-appearance: none;
  box-shadow: none !important;
}
</style>
